import { useCallback, useRef } from 'react';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { taskFromJob } from '../taskModel';
import { useTasksDrawer } from '../tasksDrawerStore';
const EMPTY = [];
export function useTasksJobs() {
    let { refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { openDrawer } = useTasksDrawer();
    const { data, isLoading, isFetching, isFetched, refresh, optimisticUpdate, error } = useQueryState({
        queryKey: [
            QueryKeys.TasksJobs
        ],
        queryFn: async ()=>(await api.jobs.getJobs()).map(taskFromJob),
        refreshOnHookMount
    });
    const optimisticUpdateRef = useRef(optimisticUpdate);
    optimisticUpdateRef.current = optimisticUpdate;
    const stableOptimisticUpdate = useCallback((updater)=>optimisticUpdateRef.current(updater), []);
    const addTask = useCallback(function(task) {
        let shouldOpen = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        stableOptimisticUpdate((tasks)=>[
                task,
                ...tasks.filter((t)=>t.jobId !== task.jobId)
            ]);
        if (shouldOpen) openDrawer();
    }, [
        stableOptimisticUpdate,
        openDrawer
    ]);
    const removeTask = useCallback((jobId)=>stableOptimisticUpdate((tasks)=>tasks.filter((t)=>t.jobId !== jobId)), [
        stableOptimisticUpdate
    ]);
    return {
        tasks: data !== null && data !== void 0 ? data : EMPTY,
        isLoading,
        isFetching,
        isSettled: isFetched,
        refresh,
        optimisticUpdate: stableOptimisticUpdate,
        addTask,
        removeTask,
        error
    };
}
